module.exports = flarum.core.compat['utils/computed'];